<template>
  <div class="main_right">
    <div class="page_info">
      <Breadcrumb class="breadcrumb">
        <BreadcrumbItem>商户管理</BreadcrumbItem>
      </Breadcrumb>
      <div class="searchBox">
        <div>
          <Button type="primary" icon="plus" @click="toAddBusiness" v-if="authList.indexOf('010002') !== -1">添加</Button>
          <Button type="error" icon="minus" @click="batchDelete" v-if="authList.indexOf('010005') !== -1">删除</Button>
        </div>
        <Input v-model="reqbody.searchKey" icon="ios-search" placeholder="商户名" style="width: 200px" @on-click="search" @keyup.13.native="search"/>
      </div>

      <Table border height="520" ref="business_table" :columns="columns" :data="tableData" @on-select-all="setAllBatch" @on-select="setBatch" @on-select-cancel="delBatch"></Table>
      <page :total="total" show-sizer class="table_page" @on-change="changePageNo" @on-page-size-change="changePageSize" show-total></page>
    </div>

    <Modal
      v-model="openSimple"
      title="提示"
      @on-ok="sureDelete"
      @on-cancel="cancelDelete">
      <p>是否确认删除商户？</p>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'
import {getAuthStr} from '../../util/bus'

export default {
  name: 'business-management',
  data () {
    return {
      authList: '',
      openSimple: false,
      reqbody: {
        searchKey: '',
        pageSize: 10,
        pageNo: 1
      },
      columns: [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '商户名',
        key: 'merchantName',
        align: 'center'
      }, {
        title: '商户代码',
        key: 'merchantCode',
        align: 'center'
      }, {
        title: '联系人姓名',
        key: 'contactName',
        align: 'center'
      }, {
        title: '联系人手机',
        key: 'contactPhone',
        align: 'center'
      }, {
        title: '联系人邮箱',
        key: 'contactMail',
        align: 'center'
      }, {
        title: '地址',
        key: 'addr',
        align: 'center'
      }, {
        title: '备注',
        key: 'memo',
        align: 'center'
      }, {
        title: '创建时间',
        key: 'createTime',
        align: 'center'
      }, {
        title: '操作',
        key: 'operation',
        align: 'center',
        render: (h, params) => {
          if (!params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteBusiness(params.row.id)
                  }
                }
              }, '删除')
            ])
          } else if (params.row.authStatusM && !params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyBusiness(params.row.id)
                  }
                }
              }, '修改')
            ])
          } else if (params.row.authStatusM && params.row.authStatusD) {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifyBusiness(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.deleteBusiness(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      }],
      tableData: [],
      total: 0,
      deleteDevId: {},
      batchId: {
        ids: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.getBusinessPage()
  },
  methods: {
    toAddBusiness () {
      this.$router.push({
        path: '/add_business'
      })
    },
    getBusinessPage () {
      this.$axios.post(`${httpUrl.url}/manage/merchant/getPage`, this.reqbody)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (this.authList.indexOf('010004') !== -1) {
              data.list.map(v => {
                v.authStatusM = true
              })
            } else {
              data.list.map(v => {
                v.authStatusM = false
              })
            }
            if (this.authList.indexOf('010005') !== -1) {
              data.list.map(v => {
                v.authStatusD = true
              })
            } else {
              data.list.map(v => {
                v.authStatusD = false
              })
            }
            data.list.map(v => {
              if (v.createTime) {
                v.createTime = v.createTime.slice(0, 19)
              } else {
                v.createTime = '--'
              }
            })
            this.tableData = data.list
            this.total = data.total
          }
        })
        .catch(errorHandler('获取数据失败'))
    },
    setAllBatch (selection) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    setBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    delBatch (selection, row) {
      let idArr = []
      selection.map(v => {
        idArr.push(v.id)
      })
      this.batchId.ids = idArr.join(',')
    },
    batchDelete () {
      if (!this.batchId.ids) {
        nError('请先选择商户')
        return false
      }
      this.deleteBusiness(this.batchId.ids)
    },
    modifyBusiness (id) {
      this.$router.push({
        path: '/modify_business/' + id
      })
    },
    deleteBusiness (id) {
      this.openSimple = true
      this.deleteDevId.ids = id.toString()
    },
    sureDelete () {
      this.$axios.post(`${httpUrl.url}/manage/merchant/deleteByIds`, this.deleteDevId)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('删除成功')
            this.openSimple = false
            this.getBusinessPage()
          }
        })
        .catch(errorHandler('删除失败'))
    },
    cancelDelete () {
      this.openSimple = false
    },
    changePageNo (m) {
      this.reqbody.pageNo = m
      this.getBusinessPage()
    },
    changePageSize (n) {
      this.reqbody.pageSize = n
      this.getBusinessPage()
    },
    search () {
      this.reqbody.pageNo = 1
      this.getBusinessPage()
    }
  }
}
</script>

<style scoped>
  .main_right {
    min-width: 780px;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }

  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .searchBox {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .table_page {
    text-align: right;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/warehouse-management/business-management.vue